import axios from "axios";
import {db_url} from "../url";

export default function DB_RemainsMobile(token) {
    const add_url = '/mobile/availability'

    const getAvailabilities = (controller, search) => {
        return axios.get(db_url + add_url, {
        // return axios.get("http://127.0.0.1:3002/api_web/v1" + add_url, {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getAvailability = (controller, search, id) => {
        return axios.get(db_url + add_url , {
        // return axios.get('http://127.0.0.1:3002/api_web/v1' + add_url, {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }


    return {
        getAvailabilities,
        getAvailability,
    }

}